import { useMemo } from 'react'
import { byStartDateAsc } from '../lib/utils'
import { isEventActive } from '../lib/formatDate'
import { getNow } from '../lib/clock'
import type { Event, Group, GroupEvent } from '../types'

/**
 * For each group, finds the next upcoming linked event (the earliest active
 * event linked via groupEvents). Returns a Map<groupId, Event>.
 */
export function useNextEventPerGroup(
  groups: Group[],
  allGroupEvents: GroupEvent[],
  events: Event[],
): Map<string, Event> {
  const now = getNow()

  return useMemo(() => {
    const map = new Map<string, Event>()
    for (const group of groups) {
      const linkedEventIds = allGroupEvents
        .filter(ge => ge.groupId === group.id)
        .map(ge => ge.eventId)
      const upcoming = events
        .filter(e => linkedEventIds.includes(e.id) && isEventActive(e, now))
        .sort(byStartDateAsc)
      if (upcoming[0]) map.set(group.id, upcoming[0])
    }
    return map
  }, [groups, allGroupEvents, events, now])
}
